import * as FileDownload from "js-file-download";

import { requestResolver, useApi } from "../api";
import { api } from "../helpers";

const prefix = "/leaderboard";

export const getFiltersDatesList = (param, token) => {
	return api(`${prefix}/filters-dates`, "GET", undefined, param, token);
};

export const getFiltersDate = (payload, token) => {
	const { id, ...param } = payload;

	return api(`${prefix}/filters-date/${id}`, "GET", undefined, param, token);
};

export const postFiltersDate = (payload, token) => {
	return api(`${prefix}/filters-date`, "POST", payload, undefined, token);
};

export const updateFiltersDate = (payload, token) => {
	return api(`${prefix}/filters-date`, "PUT", payload, undefined, token);
};

export const deleteFiltersDate = (payload, token) => {
	const { id, ...rest } = payload;

	return api(
		`${prefix}/filters-date/${id}`,
		"DELETE",
		rest,
		undefined,
		token
	);
};

export const useApiLeaderboard = () => {
	const initialState = {
		loading: false,
		data: [],
		error: null,
	};

	const { Request, state, setState } = useApi(initialState);

	const get = async (queries = {}) => {
		// On Request state
		setState((old) => ({
			...old,
			loading: true,
			error: initialState.error,
		}));

		// Api get
		await Request({
			method: "get",
			url: `points`,
			params: queries,
		})
			.then(requestResolver)
			// Success
			.then((data) => {
				setState((old) => ({
					...old,
					data,
				}));
			})
			// Error
			.catch((err) => {
				setState((old) => ({
					...old,
					error: err.message,
				}));
			});

		// After Request state
		setState((old) => ({
			...old,
			loading: false,
		}));
	};

	const exportData = async (filename = "data", queries = {}) => {
		// Api get
		await Request({
			method: "get",
			url: `points/export`,
			params: queries,
			responseType: "blob",
		})
			.then(requestResolver)
			// Success
			.then((data) => {
				FileDownload(data, `${filename}.xlsx`);
			});
	};

	return {
		state,
		get,
		exportData,
	};
};
